export default __webpack_public_path__ + "static/media/MRA-CIRCLE.752c02a7.png";